import { RootState } from '@/types/store';
import { UserRole } from '@/types/users';
import { createSelector } from '@reduxjs/toolkit';

export const selectAccount = (state: RootState) => state.account.user;
export const selectAccountIsLoading = (state: RootState) => state.account.isLoading;
export const selectAuth = (state: RootState) => Boolean(state.account.user);
export const selectIsAdmin = (state: RootState) => state.account.user?.group === UserRole.Admin;

export const selectUser = (state: RootState) => state.user.user;
export const selectUsersList = (state: RootState) => state.user.list;
export const selectUsersListIsLoading = (state: RootState) => state.user.isLoading;

export const selectNotificationsList = (state: RootState) => state.notifications.list;

export const selectNotificationsListReversed = createSelector(selectNotificationsList, notifications => {
    return [...notifications].reverse();
});

export const selectEventsList = (state: RootState) => state.events.list;
export const selectEventsListIsLoading = (state: RootState) => state.events.isLoading;
export const selectEventsListIsLoaded = (state: RootState) => state.events.isLoaded;
export const selectEventsByUsersMap = (state: RootState) => state.events.eventsByUsers;
export const selectEventsByUser = createSelector(
    [
        selectEventsByUsersMap,
        (state, userId: number | undefined) => userId,
    ],
    (eventsByUsers, userId) => userId ? eventsByUsers[userId] : [],
);

export const selectUserEventsIsLoading = (state: RootState) => state.userEvents.isLoading;
export const selectUserEventsIsLoaded = (state: RootState) => state.userEvents.isLoaded;
export const selectUserEvents = (state: RootState) => state.userEvents.list;

export const selectSendListEvent = (state: RootState) => state.sendList.event;
export const selectSendListIsLoading = (state: RootState) => state.sendList.isLoading;
export const selectSendList = (state: RootState) => state.sendList.list;
